package com.eladfinish.bible.contest.screens.settings.ui.screens

import androidx.compose.runtime.Composable
import androidx.navigation.NavController
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.apply_mikud
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.Constants.PREF_ENABLE_COUNTDOWN_ON_AMERICAN_QUESTIONS
import com.eladfinish.bible.contest.constants.Constants.PREF_MIKUD_FILTER_SWITCH
import com.eladfinish.bible.contest.navigation.back.InterceptBackWhen
import com.eladfinish.bible.contest.navigation.popBackStackSafely
import com.eladfinish.bible.contest.pref_description_mikud
import com.eladfinish.bible.contest.pref_description_mikud_off
import com.eladfinish.bible.contest.screens.settings.ui.preferences.PreferenceSwitch
import dev.icerock.moko.resources.compose.stringResource

internal const val KEY_AMERICAN_QUESTIONS_REFRESH = "american_questions_refresh"

@Composable
internal fun AmericanQuestionsSettingsScreen(
    navController: NavController,
    settings: KeyValueSettings,
) {
    InterceptBackWhen {
        navController.previousBackStackEntry
            ?.savedStateHandle
            ?.set(KEY_AMERICAN_QUESTIONS_REFRESH, true)
        navController.popBackStackSafely()
    }
    PreferenceSwitch(
        title = stringResource(SharedRes.strings.apply_mikud),
        key = PREF_MIKUD_FILTER_SWITCH,
        defaultValue = true,
        summaryOn = stringResource(SharedRes.strings.pref_description_mikud),
        summaryOff = stringResource(SharedRes.strings.pref_description_mikud_off),
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "הגבלת זמן מענה בשאלות אמריקאיות",
        key = PREF_ENABLE_COUNTDOWN_ON_AMERICAN_QUESTIONS,
        defaultValue = true,
        summaryOn = "15 שניות",
        summaryOff = "אין הגבלת זמן",
        settings = settings,
    )
}
